import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
  useGetList,
} from 'react-admin';
import { useEffect, useState } from 'react';
import { apiUrl } from '../../constants';
import { fetchUtils } from 'react-admin';

const fetchJson = (url: string, options = {}) => {
  const token = localStorage.getItem('auth') as string;
  return fetchUtils.fetchJson(url, {
    ...options,
    user: {
      authenticated: !!token,
      token,
    },
  });
};

const BillerMerchantCodeMappingCreate = () => {
  const [billerCategories, setBillerCategories] = useState<any[]>([]);

  const { data: billerMerchantCodes = [] } = useGetList('billerMerchantCodes', {
    pagination: { page: 1, perPage: 100 },
  });

  // Fetch biller categories from API
  useEffect(() => {
    fetchJson(`${apiUrl}/billerCategory`)
      .then(({ json }) => {
        let categories = [];
        if (Array.isArray(json)) {
          categories = json;
        } else if (json.data && Array.isArray(json.data)) {
          categories = json.data;
        }
        setBillerCategories(categories);
      })
      .catch((err) => {
        console.error('Error fetching biller categories:', err);
      });
  }, []);

  const merchantCodeChoices = billerMerchantCodes.map((mc: any) => ({
    id: mc.merchantCode || mc.id,
    name: mc.details || mc.merchantId || mc.id,
  }));

  return (
    <Create>
      <SimpleForm>
        <SelectInput
          source="categoryId"
          label="Biller Category"
          choices={billerCategories}
          optionText="categoryName"
          optionValue="categoryId"
          validate={[required()]}
        />
        <TextInput
          source="categoryName"
          label="Category Name"
          validate={[required()]}
          helperText="Enter the category name"
        />
        <SelectInput
          source="merchantCode"
          label="Merchant Code"
          choices={merchantCodeChoices}
          validate={[required()]}
        />
      </SimpleForm>
    </Create>
  );
};

export default BillerMerchantCodeMappingCreate;
